import { StatsDataServiceInterface } from '../../service/stats-data/service.interface';
import { StatsStoreProperty } from './store/property';
import { StatsStoreAgent } from './store/agent';
import { StatsStoreBroker } from './store/broker';
import { StatsStoreUser } from './store/user';

export class StatsData implements StatsDataServiceInterface {
  public static PROPERTY: string = 'property';
  public static AGENT: string = 'agent';
  public static BROKER: string = 'broker';
  public static USER: string = 'user';

  /**
   *
   * @param propertyStore
   * @param agentStore
   * @param brokerStore
   * @param userStore
   */
  constructor(
    protected propertyStore: StatsStoreProperty,
    protected agentStore: StatsStoreAgent,
    protected brokerStore: StatsStoreBroker,
    protected userStore: StatsStoreUser
  ) {}

  /**
   * @inheritDoc
   */
  public getPropertyStore(): StatsStoreProperty {
    return this.propertyStore;
  }

  /**
   * @inheritDoc
   */
  public getAgentStore(): StatsStoreAgent {
    return this.agentStore;
  }

  /**
   * @inheritDoc
   */
  public getBrokerStore(): StatsStoreBroker {
    return this.brokerStore;
  }

  /**
   * @inheritDoc
   */
  public getUserStore(): StatsStoreUser {
    return this.userStore;
  }
}
